import { IInventoryItemsQueryParamsForReturn } from 'gen/ApiClient';

export const DefaultInventoryItemsQueryParamsForReturn: IInventoryItemsQueryParamsForReturn = {
	searchString: '',
	sortParams: { direction: 'desc', property: 'created' },
	pageParams: { index: 1, size: 10 },
	categories: [],
	subcategories: [],
	forProductCatalogId: undefined,
	isShowAll: false,
};
